module.exports = __webpack_public_path__ + "static/img/scan-code3.fb84e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/scan-code3.png
// module id = fqiz
// module chunks = 1